import { render } from "./mute-logo.vue?vue&type=template&id=0c62de31"
import script from "./mute-logo.vue?vue&type=script&lang=js"
export * from "./mute-logo.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__